module.exports = __webpack_public_path__ + "img/pic_home_jigou_bg@2x.e79e2f92.png";